module.exports = __webpack_public_path__ + "static/media/woman.15ca0fce.jpg";